module.exports = __webpack_public_path__ + "img/ico_carteirinha.14ece333.svg";